export default __webpack_public_path__ + "static/media/genomics-card.64bd9eb3.png";